import { apiClient } from '@cyberint/common-utils';

export const REDIRECT_ERROR_CODE = 152; // Missing infinity_ids mapping
export const MISSING_ERM_USER_ROLE_ERROR_CODE = 153; // missing Specific ERM Role (admin, consumer, producer)
export const INVALID_TOKEN_ERROR = 'Bad first time token'; // TODO - delete when error code is exposed
export const INVALID_TOKEN_ERROR_CODE = 157; // Bad first time token
export const INSUFFICIENT_ERM_USER_QUOTA_ERROR_CODE = 123; // Insufficient Users quota
export const USER_DISABLED = 156;
export const UN_AUTHORIZED_ERROR = 'Bad Username/Password/IP address'; // IP address not allowed

export const REDIRECTED_FROM = 'redirectedFrom';
export const REGISTERED_ORIGIN = 'registeredOrigin';

export const fixFirstPath = path => {
  if (!path?.startsWith('#') || path === '#/erm') return null;
  let newPath = path.split('#')[1];
  if (newPath && !newPath.startsWith('/')) {
    newPath = `/${newPath}`;
  }
  if (newPath && !newPath.endsWith('/')) {
    newPath = `${newPath}/`;
  }
  return newPath;
};

export const buildEmbeddedRedirectUrl = (targetServer, fixedPath, basePath = '') => {
  const url = new URL(window.location.href);

  url.host = targetServer;
  url.port = '';

  let pathname = url.pathname;

  if (fixedPath) {
    const fixedUrl = new URL(fixedPath, window.location.origin);
    pathname = pathname.replace(basePath, `${basePath}${fixedUrl.pathname}`).replace('//', '/');

    // fixFirstPath appends trailing slashes to paths; strip them off query values.
    fixedUrl.searchParams.forEach((value, key) => {
      url.searchParams.set(key, value.replace(/\/+$/, ''));
    });
  }

  url.pathname = pathname;
  url.searchParams.set(apiClient.PARENT_REF_HEADER, apiClient.getDocumentReferrer());
  url.searchParams.set(REDIRECTED_FROM, window.location.host);
  url.searchParams.set(REGISTERED_ORIGIN, window.location.origin);

  return url.href;
};

export const sanitizeURL = url => {
  try {
    const parsed = new URL(url);
    if (parsed.searchParams.has('firstTimeToken')) {
      parsed.searchParams.set('firstTimeToken', '****');
    }
    return parsed.toString();
  } catch {
    return url;
  }
};
